import styles from './PublisherHeader.module.scss'

interface LanguageMenuProps {
  title: string
  languageItems: JSX.Element[]
}

function LanguageMenu ({ title, languageItems }: LanguageMenuProps) {
  return (
    <div className={styles.languageSection}>
      <h3>{title}</h3>
      <div className={styles.languageItem}>
        {languageItems}
      </div>
    </div>
  )
}

export default LanguageMenu
